import React, { ChangeEvent, useState } from 'react'
import Fuse from 'fuse.js'
import { prepareData } from 'utils/googleData'

export const FAQs = (props) => {
    const {
        enable,
        title,
        subtitle,
        description,
        text,
        faqs,
        direction,
        style,
        className,
        gatsbyImage,
        features,
        gatsbyImage2,
        imageMaxWidth,
        imageMaxHeight,
    } = prepareData({ props })
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    // console.log(`allFAQs ${JSON.stringify(allFAQs)}`)
    const fuse = new Fuse(faqs, { keys: ['q', 'a'], includeMatches: true })
    const [questions, setQuestions] = useState(faqs)
    const [openIndex, setOpenIndex] = useState(null)

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        const filtered = fuse.search(e.target.value).map((item) => item.item)
        setQuestions(filtered.length ? filtered : faqs)
    }
    const toggleFAQ = (index) => {
        setOpenIndex(openIndex === index ? null : index)
    }
    return (
        <>
            <h2 dir={direction} className="m-0 mb-6 border-b border-dashed border-gray-accent-light pb-6 text-2xl">
                {title}
            </h2>
            <section dir={direction} className={`${className}`}>
                <input
                    onChange={handleChange}
                    placeholder={text}
                    className="w-full rounded-sm bg-gray-accent-light py-3 px-4 text-[15px] font-semibold"
                />
                <ul className="m-0 mt-4 grid list-none gap-y-6 p-0">
                    {questions &&
                        questions.map((faq, index) => {
                            const { q, a } = faq
                            let author = faq?.author
                            if (Array.isArray(author) && author.length == 1) author = author[0]
                            let authorQ = author?.q
                            if (Array.isArray(authorQ) && authorQ.length == 1) authorQ = authorQ[0]
                            let authorA = author?.a
                            if (Array.isArray(authorA) && authorA.length == 1) authorA = authorA[0]
                            return (
                                <li key={index} onClick={() => toggleFAQ(index)} className="cursor-pointer">
                                    <div className="relative flex items-center space-x-2">
                                        <span className="relative flex-shrink-0">
                                            <span className="absolute left-1/2 h-full w-full translate-y-[55%] rounded-sm border-l border-b border-dashed border-gray-accent-light" />
                                            {/* <span>{authorQ?.img}</span> */}
                                            <span
                                                className={`indicator m-0 text-[15px] font-semibold ${
                                                    openIndex === index ? 'open' : 'closed'
                                                }`}
                                            >
                                                {openIndex === index ? '-' : '+'}
                                            </span>
                                        </span>
                                        <p className="m-0 text-[15px] font-semibold">{q}</p>
                                    </div>
                                    {openIndex === index && (
                                        <div className="ml-[calc(40px+.5rem)] flex items-start space-x-2 pt-2">
                                            {/* <span className="flex-shrink-0">{authorA?.img}</span> */}
                                            <span>
                                                {/* <p className="m-0 text-[15px] font-semibold text-red">{authorA?.name}</p> */}
                                                <p className="m-0 text-[14px] font-normal">{a}</p>
                                            </span>
                                        </div>
                                    )}
                                </li>
                            )
                        })}
                </ul>
            </section>
        </>
    )
}
export default FAQs
